import { render } from "./TotalScansLineChart.vue?vue&type=template&id=2679013f"
import script from "./TotalScansLineChart.vue?vue&type=script&lang=js"
export * from "./TotalScansLineChart.vue?vue&type=script&lang=js"

import "./TotalScansLineChart.vue?vue&type=style&index=0&id=2679013f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__